import { render, staticRenderFns } from "./PowerPlant.vue?vue&type=template&id=095dd8d8&scoped=true&"
import script from "./PowerPlant.vue?vue&type=script&lang=js&"
export * from "./PowerPlant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095dd8d8",
  null
  
)

export default component.exports